import { PaginationResultDTO } from "../dto/PaginatedResultsDTO";
import { PaginatedResults } from "../models/PaginatedResults";

/**
 * Map the paginated results object, then map the records to their appropriate model,
 * @param dto Response from a "paginated" endpoint
 * @param recordMapper Mapper function for the records
 * @example paginationResultsMapper<Signout>(response.data, signoutMapper);
 * // Because the contained records could be any type, we have to pass the model in as RecordType
 */
export const paginationResultsMapper = <RecordModel>(
  dto: PaginationResultDTO,
  recordMapper: (value: any) => RecordModel,
) => {
  return new PaginatedResults({
    // Map the contained records using the mapper function associated with the model
    records: dto.records.map(recordMapper) as RecordModel[],
    totalRecords: dto.totalRecords || 0,
    limit: dto.limit || 0,
    offset: dto.offset || 0,
  });
};
